function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M498.133,241.585c8.768-8.811,13.867-20.757,13.867-33.579c0-18.496-10.581-34.752-26.325-42.688 c3.264-6.528,4.992-13.76,4.992-21.312c0-18.496-10.603-34.773-26.347-42.688c4.864-9.728,6.293-20.928,3.84-32.043 c-4.779-21.611-25.109-37.269-48.341-37.269H224c-14.827,0-38.72,4.8-56.469,13.931c-7.424-20.544-27.136-35.264-50.197-35.264 h-64C23.915,10.673,0,34.587,0,64.006v170.667c0,29.419,23.915,53.333,53.333,53.333H160c5.888,0,10.667-4.779,10.667-10.667 v-4.075l2.539,1.28l61.461,133.12v72.341c0,3.243,1.472,6.315,3.989,8.341c0.683,0.512,16.533,12.992,38.677,12.992 c24.683,0,64-39.061,64-85.333c0-29.184-10.453-65.515-16.981-85.333h131.776c28.715,0,53.141-21.248,55.659-48.363 C513.173,267.099,508.096,252.486,498.133,241.585z M475.328,250.182c10.475,6.464,16.32,18.027,15.189,30.187 c-1.493,16.235-16.597,28.971-34.389,28.971H309.333c-3.499,0-6.784,1.728-8.789,4.608c-1.984,2.901-2.432,6.592-1.173,9.856 c0.192,0.533,20.629,54.656,20.629,92.203c0,34.944-30.976,64-42.667,64c-9.195,0-16.917-3.349-21.333-5.781v-68.885 c0-1.536-0.341-3.072-1.003-4.48l-64-138.667c-1.003-2.176-2.731-3.968-4.907-5.056l-21.333-10.667 c-3.307-1.664-7.253-1.451-10.368,0.448c-3.136,1.963-5.056,5.397-5.056,9.088v10.667h-96c-17.643,0-32-14.357-32-32V64.006 c0-17.643,14.357-32,32-32h64c17.643,0,32,14.357,32,32c0,4.309,2.603,8.213,6.592,9.856c3.968,1.621,8.555,0.725,11.627-2.304 C177.621,61.467,206.677,53.339,224,53.339h195.819c13.312,0,24.875,8.619,27.499,20.565c2.112,9.536-0.704,18.795-7.723,25.429 c-3.029,2.837-4.139,7.168-2.816,11.136c1.323,3.947,4.8,6.763,8.917,7.232c13.461,1.536,23.637,12.843,23.637,26.304 c0,7.339-3.008,14.208-8.405,19.328c-3.029,2.837-4.139,7.168-2.816,11.136c1.323,3.947,4.8,6.763,8.917,7.232 c13.461,1.536,23.637,12.843,23.637,26.304c0,9.941-5.589,18.987-14.613,23.595c-3.413,1.771-5.611,5.227-5.781,9.088 C470.123,244.529,472.064,248.155,475.328,250.182z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M160,53.339c-5.888,0-10.667,4.779-10.667,10.667v192c0,5.888,4.779,10.667,10.667,10.667s10.667-4.779,10.667-10.667 v-192C170.667,58.118,165.888,53.339,160,53.339z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.012 512.012",
    style: {
      enableBackground: "new 0 0 512.012 512.012"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.39b05d80.svg";
export { ForwardRef as ReactComponent };